export const tashkeelRegex = /[\u0617-\u061A\u064B-\u0652]/g;

export const removeTashkeel = (text: string) => {
    return text.replace(tashkeelRegex, '');
};
